export default "__VITE_ASSET__CL3llam9__"